module.exports = __webpack_public_path__ + "static/media/powered-by-stripe.ae1a425b.svg";